import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sts-lower-bar',
  templateUrl: './sts-lower-bar.component.html',
  styleUrls: ['./sts-lower-bar.component.scss']
})
export class StsLowerBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
